import { defineStore } from "pinia";
import { ref } from "vue";
import router from "@/router";
import { useApiClient } from "@/utils/apiClient.js";
import { useLocalization } from "@/locales/localization";

export const useAuthStore = defineStore(
  "auth",
  () => {
    const api = useApiClient();
    const localization = useLocalization();

    const user = ref(null);
    const returnUrl = ref(null);

    function isAuthenticated() {
      return user.value !== null;
    }

    function resetLogin() {
      user.value = null;
      router.push("/login");
    }

    async function login(username, password) {
      var authResult = await api.post("/account/login", { userName: username, password: password });
      if (!authResult.ok) return false;

      user.value = authResult.data;
      if (user.value.preferredLanguageCode) {
        localization.localeSet(user.value.preferredLanguageCode);
      }

      return true;
    }

    async function logout() {
      await api.post("/account/logout");
      resetLogin();
    }

    async function preferredLocaleSet(localeCode) {
      api.post("/account/PreferredLanguageCodeSet", localeCode);
      user.value.preferredLanguageCode = localeCode;
    }

    function hasPermission(permissionCode) {
      var result = false;
      permissionCode = permissionCode.toString().toLowerCase();

      if (user.value !== null) {
        for (var i = 0; i < user.value.userData.permissions.length; i++) {
          if (user.value.userData.permissions[i].code.toLowerCase() === permissionCode) {
            result = true;
            break;
          }
        }
      }

      return result;
    }

    return {
      user,
      returnUrl,
      isAuthenticated,
      resetLogin,
      login,
      logout,
      preferredLocaleSet,
      hasPermission,
    };
  },
  {
    persist: true,
  }
);
